<template>
    <m-pageframe title="Guest Check In Forms Demo">
        <v-container>
            <v-row
                class="mt-2 mb-12"
                justify="center"
            >
                <v-col
                    v-for="experience in experiences"
                    :key="experience.id"
                    cols="12"
                    sm="6"
                    xl="3"
                >
                    <v-card
                        class="experience-card"
                        elevation="3"
                    >
                        <v-card-title class="pb-0 text-h6">
                            {{ experience.title }}
                        </v-card-title>

                        <v-card-text>
                            <p class="mb-8">{{ experience.description }}</p>

                            <div class="qr-code-container text-center mb-4">
                                <div class="qr-code">
                                    <v-icon
                                        v-if="!experience.qr_code_id"
                                        large
                                    >mdi-qrcode</v-icon>
                                    <qr-code
                                        v-else
                                        :qr_code_id="experience.qr_code_id"
                                    />
                                </div>
                                <div class="caption mt-2">Scan to experience on mobile</div>
                            </div>
                        </v-card-text>

                        <v-card-actions>
                            <v-btn
                                color="primary"
                                block
                                type="button"
                                target="_blank"
                                :to="experience.to"
                            >
                                Try Experience
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </m-pageframe>
</template>

<script>
import _ from 'lodash';
import QrCode from "@/components/demos/guest-checkin/qr-code.vue";

export default {
    components: {
        QrCode,
    },

    data() {
        return {
            experiences: [
                {
                    id: '12fbcbc7-bda3-4453-998d-d4cdbb81aa7a',
                    qr_code_id: null,
                    title: 'Default Check In',
                    description: 'Our proposed default guest check-in experience with streamlined consent gathering.',
                    to: {
                        name: 'search-forms-guest-check-in-demo-default',
                    }
                },
                {
                    id: '40bb87b5-a117-4dd8-a675-f12dfe651b72',
                    qr_code_id: null,
                    title: 'Conservative Check In',
                    description: 'A conservative approach with explicit checkbox consent for each communication channel.',
                    to: {
                        name: 'search-forms-guest-check-in-demo-conservative',
                    }
                },
                {
                    id: '40ab47d2-03a2-457d-8fdf-de4086b1702b',
                    qr_code_id: null,
                    title: 'Discount Check In',
                    description: 'A discount-themed experience that incentivizes opt-in with a 10% off offer upon check-in.',
                    to: {
                        name: 'search-forms-guest-check-in-demo-discount',
                    }
                }
            ]
        }
    },

    async mounted() {
        for (const experience of this.experiences) {
            if (!experience.qr_code_id) {
                await new Promise(resolve => {
                    this.$rc.rest({
                        spinner: true,
                        endpoint: 'PUT: /api/v1/guest-check-in/forms/generate-qr-code',
                        params: {
                            guest_check_in_form_id: experience.id
                        },
                        on_success: (data) => {
                            this.$set(experience, 'qr_code_id', data.qr_code_id);
                            resolve();
                        },
                        on_error: () => {
                            resolve();
                        }
                    });
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.experience-card {
    height: 100%;
    display: flex;
    border-radius: 8px;
    flex-direction: column;
    padding-bottom: 1.2rem;
    border-top: 3px solid var(--v-primary-base);
}

.qr-code-container {
    .qr-code {
        width: 12rem;
        height: 12rem;
        border: 2px dashed #ccc;
        border-radius: 0.5rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
    }
}

:deep(.v-card__text) {
    flex-grow: 1;
}

:deep(.v-card__actions) {
    padding: 0 16px;
}
</style>